import './toast.css';
import useToast from "../../hooks/useToast";
import {Button} from "antd";
import {useState} from "react";
import {useLocation} from "react-router-dom";

const Toast = () => {
    const { isShown, text, skin, buttons, type, title, icon, closeToast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const [clickedButtonText, setClickedButtonText] = useState('');
    const { pathname } = useLocation();
    if (pathname === "/vivo") return null;

    const onClick = async (button: any) => {
        setIsLoading(true);
        setClickedButtonText(button.text);
        await button.onClick();
        setIsLoading(false);
    }
    if(type === 'notification') {
        return (
            <div className={`toast-notification-container ${skin} ${isShown ? 'shown' : ''}`}>
                <div className="notification-close-button" onClick={() => closeToast()}>x</div>
                <div className="notification-top">
                    {icon ? <div className="toast-icon">{icon}</div> : null}
                    <div className="toast-content">
                        {title ? <div className="toast-title">{title}</div> : null}
                        <div className="toast-message">{text}</div>
                    </div>
                </div>
                {buttons?.length ?
                    <div className="notification-bottom">
                        <div className="toast-approve">
                            {buttons.map(button => <Button className="toast-notification-button" key={`toast-notification-button-${button.text}`} onClick={button.onClick}>{button.text}</Button>)}
                        </div>
                    </div>
                    : null}
            </div>
        )
    } else {
        return (
            <>
                {buttons?.length ? <div className="toast-blocker" /> : null}
                <div className={`toast-container ${skin} ${isShown ? 'shown' : ''}`}>
                    <div className="toast-inner">
                        <div className="toast-main">
                            {icon ? <div className="toast-icon">{icon}</div> : null}
                            <div className="toast-message">{text}</div>
                        </div>
                        {buttons?.length ? <div className="toast-approve">
                            {buttons.map(button => <Button
                                disabled={isLoading}
                                loading={isLoading && clickedButtonText === button.text}
                                className="toast-button" key={`toast-button-${button.text}`}
                                onClick={() => onClick(button)}>{button.text}
                            </Button>)}
                        </div> : null}
                    </div>
                </div>
            </>
        )
    }
}

export default Toast;
